<template>
  <div class="bg-gray-50 flex flex-col pt-5 px-4 lg:px-0 md:items-center md:justify-start">
    <!-- Indietro button: Mobile only -->
    <div class="w-full flex justify-start">
      <button
        class="flex items-center gap-2 text-primary font-semibold text-base py-2 px-0 mb-2"
        @click="goBack"
        type="button"
        aria-label="Indietro"
        style="width: fit-content;"
      >
        <i class="bx bx-chevron-left text-2xl" style="margin-left: -4px;"></i>
        Indietro
      </button>
    </div>
    <!-- Content -->
    <div class="mt-0 md:mx-auto md:w-full">
      <div class="flex flex-col md:flex-row md:gap-8 pb-20 md:pb-0 box-border">
        <!-- Left column: cover, specs card, candidati button (desktop only) -->
        <div class="md:w-1/3 md:flex md:flex-col md:gap-1">
          <!-- Cover: show at top of left column on desktop, at top of page on mobile -->
          <div class="relative rounded-2xl overflow-hidden md:mx-0 md:w-full mb-4 md:mb-0">
            <div class="absolute inset-0 bg-gradient-to-b from-black to-transparent h-1/2 z-10" style="opacity: 0.6;"></div>
            <div class="relative pb-4">
              <CuCastingThumb
                :image="casting.image"
                :title="casting.title"
                :bg="casting.bg"
                :casting-id="casting.codice"
                class="w-full max-w-full md:h-52"
                style="min-width:100%;max-width:100%;"
                text-class="text-base md:text-2xl font-bold"
                :subscriptionStatus="subscriptionStatus"
              />
              
            </div>
            
          </div>
          <!-- Description: Mobile only, before specs -->
          <div class="text-gray-700 text-base mb-4 text-left mt-5 md:hidden">
            <span v-if="!showFullDesc" style="white-space: pre-line;">{{ shortDescription.trim() }}</span>
            <span v-else style="white-space: pre-line;">{{ casting.description.trim() }}</span>
            <a v-if="needsSeeMore && !showFullDesc" @click="showFullDesc = true" class="text-primary font-semibold cursor-pointer" style="float: right;">Vedi di più</a>
          </div>
          <CuCastingSpecsCard
            :pay="casting.pay"
            :date="casting.date"
            :place="casting.place"
            :requirements="casting.requirements"
            :region="casting.region"
            class="mb-4 w-full md:p-8 md:shadow-xl md:max-w-none mb-8"
          />
          <!-- Candidati button: Desktop (immediately below card, same width) -->
          <div class="hidden md:block mt-4" v-if="!inSheet">
            <template v-if="canCandidate">
              <CuButton
                v-if="subscriptionStatus === -1 || subscriptionStatus === 4"
                primary
                class="w-full"
                @click="handleCandidatiClick"
              >Candidati</CuButton>
              <CuButton
                v-else-if="subscriptionStatus === 3 || subscriptionStatus === 5"
                class="w-full bg-gray-300 text-gray-500 cursor-not-allowed"
                disabled
              >Candidati</CuButton>
              <CuButton
                v-else
                primary
                class="w-full"
                @click="() => {}"
              >Candidati</CuButton>
            </template>
            <CuButton
                v-else-if="subscriptionStatus === 0 || subscriptionStatus === 1 || subscriptionStatus === 2 || subscriptionStatus === 6"
                primary
                class="w-full"
                @click="onRemoveClick"
              >Rimuovi candidatura</CuButton>
            <template v-else>
              <CuButton class="w-full bg-gray-300 text-gray-500 cursor-not-allowed" disabled>
                Candidati
              </CuButton>
            </template>
          </div>
        </div>
        <!-- Right column: description (desktop only) -->
        <div class="md:w-2/3">
          <!--<div class="text-gray-400 text-base md:text-base mb-2 font-semibold text-left">Dettagli casting</div>-->
          <div class="text-gray-700 text-base mb-6 pb-6 text-left my-5 hidden md:block">
            <span v-if="!showFullDesc" style="white-space: pre-line;">{{ shortDescription }}</span>
            <span v-else style="white-space: pre-line;">{{ casting.description }}</span>
            <a v-if="needsSeeMore && !showFullDesc" @click="showFullDesc = true" class="text-primary font-semibold cursor-pointer" style="float: right;">Vedi di più</a>
          </div>
        </div>
      </div>
    </div>
    <!-- Candidati button: Mobile (footer) -->
    <div v-if="!inSheet" class="flex md:hidden fixed bottom-0 pb-5 left-0 right-0 bg-white border-t border-gray-100 px-4 py-3 z-50">
      <template v-if="canCandidate">
        <CuButton
          v-if="subscriptionStatus === -1 || subscriptionStatus === 4"
          primary
          @click="handleCandidatiClick"
        >Candidati</CuButton>
        
        <CuButton
          v-else-if="subscriptionStatus === 3 || subscriptionStatus === 5"
          class="w-full bg-gray-300 text-gray-500 cursor-not-allowed"
          disabled
        >Candidati</CuButton>
        <CuButton
          v-else
          primary
          @click="() => {}"
        >Candidati</CuButton>
      </template>
      <CuButton
          v-else-if="subscriptionStatus === 0 || subscriptionStatus === 1 || subscriptionStatus === 2 || subscriptionStatus === 6"
          primary
          @click="onRemoveClick"
        >Rimuovi candidatura</CuButton>
      <template v-else>
        <CuButton class="w-full bg-gray-300 text-gray-500 cursor-not-allowed" disabled>
          Candidati
        </CuButton>
      </template>
    </div>
  
    <CandidateModal
      :show="showCandidateModal"
      :user="appUser || user"
      @close="showCandidateModal = false"
      @proceed="handleProceed"
      @logout="handleLogout"
    />
    <CandidateQuestionsModal
      :show="showQuestionsModal"
      @close="showQuestionsModal = false"
      @confirm="handleQuestionsConfirm"
      :question="casting.domanda"
    />
    <CandidateSuccessModal
      :show="showSuccessModal"
      :user="appUser"
      @close="showSuccessModal = false"
    />
    <CandidateLoginTypeModal
      :show="showLoginTypeModal"
      @close="showLoginTypeModal = false"
      @phone="openPhoneLogin"
      @email="openEmailLogin"
    />
    <PhoneNumberSheet
      :show="showPhoneSheet"
      :error="phoneVerifyError"
      @close="showPhoneSheet = false"
      @confirm="handlePhoneLogin"
    />
    <EmailSheet
      :show="showEmailSheet"
      :error="emailVerifyError"
      @close="showEmailSheet = false"
      @confirm="handleEmailLogin"
    />
    <PhoneCodeSheet
      :show="showPhoneCodeSheet"
      :error="phoneCodeError"
      :resend-success="phoneCodeResendSuccess"
      @close="showPhoneCodeSheet = false"
      @confirm="handlePhoneCodeConfirm"
      @resend="handlePhoneCodeResend"
    />
    <NewUserOnboardingSheet
      :show="showNewUserSheet"
      @close="showNewUserSheet = false"
      @start="handleStartOnboarding"
    />
    <ProfileSelectSheet
      :show="showProfileSelectSheet"
      :profiles="profileOptions"
      @close="showProfileSelectSheet = false"
      @select="handleProfileSelect"
    />
  <!-- Loading Spinner Overlay -->
  <div v-if="isLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
    <i class="bx bx-loader-alt text-6xl text-primary animate-spin"></i>
  </div>
</div>
</template>

<script>
import CuButton from '../components/cu/CuButton.vue'
import CuCastingThumb from '../components/cu/CuCastingThumb.vue'
import CuCastingSpecsCard from '../components/cu/CuCastingSpecsCard.vue'
import CandidateModal from '../components/dialog-sheets/CandidateModal.vue'
import CandidateQuestionsModal from '../components/dialog-sheets/CandidateQuestionsModal.vue'
import CandidateSuccessModal from '../components/dialog-sheets/CandidateSuccessModal.vue'
import CandidateLoginTypeModal from '../components/dialog-sheets/CandidateLoginTypeModal.vue'
import PhoneNumberSheet from '../components/dialog-sheets/PhoneNumberSheet.vue'
import EmailSheet from '../components/dialog-sheets/EmailSheet.vue'
import PhoneCodeSheet from '../components/dialog-sheets/PhoneCodeSheet.vue'
import NewUserOnboardingSheet from '../components/dialog-sheets/NewUserOnboardingSheet.vue'
import ProfileSelectSheet from '../components/dialog-sheets/ProfileSelectSheet.vue'
import appClient from '../api/appClient.js'
import eventBus from '../utils/eventBus.js'

import { inject } from 'vue'

export default {
  name: "CastingDetail",
  props: {
    inSheet: { type: Boolean, default: false },
    castingId: { type: [String, Number], default: null }
  },
  components: {
    CuButton,
    CuCastingThumb,
    CuCastingSpecsCard,
    CandidateModal,
    CandidateQuestionsModal,
    CandidateSuccessModal,
    CandidateLoginTypeModal,
    PhoneNumberSheet,
    EmailSheet,
    PhoneCodeSheet,
    NewUserOnboardingSheet,
    ProfileSelectSheet
  },
  data() {
    return {
      casting: {},
      showFullDesc: true, // Show full description by default
      showCandidateModal: false,
      showQuestionsModal: false,
      showSuccessModal: false,
      showLoginTypeModal: false,
      showPhoneSheet: false,
      showPhoneCodeSheet: false,
      showNewUserSheet: false,
      showEmailSheet: false,
      emailVerifyError: null,
      appUser: null,
      appToken: null,
      user: null,
      loadingUser: null,
      showProfileSelectSheet: false,
      profileOptions: [],
      selectedProfile: null,
      medias_count: 0,
      phoneCodeError: null,
      phoneVerifyError: null,
      isLoading: false, // Loading state for API requests
      
      phoneCodeResendSuccess: false,
      phone: '',
    }
  },
  created() {
    // Inject global user and loadingUser
    this.user = inject('user')
    this.loadingUser = inject('loadingUser')
    // Fetch casting details from API
    this.fetchCastingDetail()
    this.fetchUserMediasCount()

    // if desktop show full description by default
    if(window.innerWidth >= 768) {
      this.showFullDesc = true
    }
  },
  computed: {
    shortDescription() {
      if (!this.casting.description) return ''


      return this.casting.description.slice(0, 200)
    },
    needsSeeMore() {
      return this.casting.description && this.casting.description.length > 90
    },
    canCandidate() {
      if(!this.user){
        return true;
      }
      // User can subscribe if puo_iscriversi is true
      return this.casting && this.casting.puo_iscriversi === 1 && (this.subscriptionStatus === -1 || this.subscriptionStatus === 4); // not subscribed or retired
    },
    subscriptionStatus() {
      // Return stato_iscrizione or -1 if not set
      return typeof this.casting?.stato_iscrizione === 'number' ? this.casting.stato_iscrizione : -1
    },
    badgeInfo() {
      // Map status to label and colors
      const status = this.subscriptionStatus
      switch (status) {
        case 0:
        case 1:
          return {
            label: "CANDIDATO",
            textColor: "text-white",
            bgColor: "bg-primary"
          }
        case 2:
          return {
            label: "CONFERMATO",
            textColor: "text-white",
            bgColor: "bg-green-400"
          }
        case 3:
          return {
            label: "NON SELEZIONATO",
            textColor: "text-white",
            bgColor: "bg-red-500"
          }
        case 5:
          return {
            label: "CASTING CHIUSO",
            textColor: "text-black",
            bgColor: "bg-yellow-300"
          }
        case 6:
          return {
            label: "OPZIONATO",
            textColor: "text-black",
            bgColor: "bg-yellow-300"
          }
        case 4:
        case -1:
        default:
          return {
            label: "",
            textColor: "text-transparent",
            bgColor: "bg-transparent"
          }
      }
    }
  },
  methods: {
    async fetchUserMediasCount() {
      this.isLoading = true;
      try {
        // Images
        const imagesRes = await appClient.post('/media/mymedia', { type: 1 });
        if (imagesRes.data && imagesRes.data.status && Array.isArray(imagesRes.data.data)) {
          this.medias_count = imagesRes.data.data.length;
        } else {
          this.medias_count = 0;
        }
      } catch (e) {
        console.error('Error fetching user media count:', e);
      } finally {
        this.isLoading = false;
      }
    },

    postLoginCandidateFlow() {
      // If user has fewer than 3 media files, show warning
      if (this.medias_count < 3) {
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Devi caricare almeno 3 foto per candidarti.",
            type: 'error'
          })
        }
        return
      }
      console.log('postLoginCandidateFlow called')
      if (this.canCandidate) {
        console.log('User can candidate, showing CandidateModal')
        this.showCandidateModal = true
        this.showSuccessModal = false
        this.showNewUserSheet = false
      } else if([0, 1, 2, 6].includes(this.subscriptionStatus)) {
        console.log('User is already subscribed, showing SuccessModal')
        this.showCandidateModal = false
        this.showSuccessModal = false
        this.showNewUserSheet = false

        // 0 = CANDIDATO, 1 = CONFERMATO, 2 = OPZIONATO, 6 = OPZIONATO, say to the user that is already subscribed
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Ti sei già candidato a questo casting.",
            type: 'info',
            title: "Candidatura già inviata"
          })
        }
      } else {
        console.log('User cannot candidate, showing NewUserSheet')
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Non puoi candidarti a questo casting con il profilo selezionato.",
            type: 'error'
          })
        }
        this.showCandidateModal = false
        this.showSuccessModal = false
        this.showNewUserSheet = false
      }
    },

    goBack() {
      this.$router.push('/overview');
    },
    async onRemoveClick() {
      this.isLoading = true;
      try {
        const res = await appClient.post('/casting/ritiro', {
          id_casting: this.$route.params.id
        });
        if (res.data && res.data.status) {
          await this.fetchCastingDetail();
          if (typeof window !== 'undefined' && window.$toast) {
            window.$toast({
              message: "Hai annullato con successo la tua candidatura al casting.",
              type: 'success',
              title: "Candidatura annullata"
            });
          }
        } else {
          if (typeof window !== 'undefined' && window.$toast) {
            window.$toast({
              message: "Errore durante la rimozione della candidatura. Riprova più tardi.",
              type: 'error'
            });
          }
        }
      } catch (e) {
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Errore durante la rimozione della candidatura. Riprova più tardi.",
            type: 'error'
          });
        }
        // eslint-disable-next-line no-console
        console.error('Errore durante ritiro candidatura:', e)
      } finally {
        this.isLoading = false;
      }
    },
    async fetchCastingDetail() {
      this.isLoading = true;
      const id = this.$route.params.id || this.castingId;
      let r_user_id = null
      if (this.user && this.user.value && this.user.value.user_id) {
        r_user_id = this.user.value.user_id
      }
      try {
        const res = await appClient.post('/web/casting/singolo', {
          id_casting: Number(id),
          r_user_id: r_user_id
        })
        if (res.data && res.data.status && res.data.data) {
          const d = res.data.data
          // Map API response to local casting object
          this.casting = {
            codice: d.codice,
            image: d.immagine,
            title: d.nome,
            description: d.descrizione,
            pay: d.valore_compenso || d.tipo_compenso || '',
            date: d.data?.data_inizio_completa || d.data_completa || '',
            place: d.luogo_completo || '',
            requirements: (d.caratteristiche || []).reduce((acc, c) => {
              acc[c.label] = c.valore
              return acc
            }, {}),
            agency: d.agenzia?.nome || '',
            domanda: d.domanda,
            risposta_obbligatoria: d.risposta_obbligatoria,
            testo_conferma_candidatura: d.testo_conferma_candidatura,
            puo_iscriversi: d.puo_iscriversi || false,
            stato_iscrizione: d.stato_iscrizione,
            region: Array.isArray(d.geo) && d.geo.length > 0 ? d.geo[0].valore : '',
          }
        }
      } catch (e) {
        // Optionally handle error, fallback to empty casting
        this.casting = {
          image: '',
          title: '',
          description: '',
          pay: '',
          date: '',
          place: '',
          requirements: {},
          agency: '',
          domanda: '',
          risposta_obbligatoria: 0,
          testo_conferma_candidatura: ''
        }
      } finally {
        this.isLoading = false;
      }
    },
    handleCandidatiClick() {
      // If user is logged in, show CandidateModal, else show CandidateLoginTypeModal
      if (this.user ) {
        this.postLoginCandidateFlow();
      } else {
        this.showCandidateLoginTypeModal()
      }
    },
    showCandidateLoginTypeModal() {
      this.showCandidateModal = false
      this.showLoginTypeModal = true
    },
    handleProceed() {
      this.showCandidateModal = false
      this.showQuestionsModal = true
    },
    async handleQuestionsConfirm(answer) {
      this.isLoading = true;
      try {
        const res = await appClient.post('/casting/iscrizione', {
          id_casting: this.$route.params.id,
          risposta: answer
        })
        this.showQuestionsModal = false
        if (res.data && res.data.status) {
          // Refresh casting details to get the updated status
          await this.fetchCastingDetail();
          this.showSuccessModal = true
        } else {
          if (typeof window !== 'undefined' && window.$toast) {
            window.$toast({
              message: "Errore durante l'iscrizione al casting. Riprova più tardi.",
              type: 'error'
            })
          }
        }
      } catch (e) {
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Errore durante l'iscrizione al casting. Riprova più tardi.",
            type: 'error'
          })
        }
        // eslint-disable-next-line no-console
        console.error('Errore durante iscrizione casting:', e)
      } finally {
        this.isLoading = false;
      }
      // eslint-disable-next-line no-console
      console.log('Candidate answer:', answer)
    },
    handleLogout() {
      // Clear token and user info on logout
      localStorage.removeItem('castingup_app_token');
      if (this.user) {
        this.user = null;
      }
      this.appUser = null;
      this.appToken = null;
      this.showCandidateModal = false
      this.showLoginTypeModal = true
    },
    openPhoneLogin() {
      this.showLoginTypeModal = false
      this.showPhoneSheet = true
    },
    openEmailLogin() {
      this.showLoginTypeModal = false
      this.showEmailSheet = true
    },
    async handleEmailLogin({ email, password }) {
      this.emailVerifyError = null
      this.isLoading = true;
      try {
        const hashPassword = async (password) => {
          const encoder = new TextEncoder();
          const data = encoder.encode(password);
          const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        };
        const hashedPassword = await hashPassword(password);
        const response = await appClient.post('/login', { email, password: hashedPassword });
        if (response.data && response.data.status && response.data.data) {
          this.appUser = response.data.data
          this.appToken = response.data.data.token
          localStorage.setItem('castingup_app_token', response.data.data.token)
          console.log('userRefresh event emitted')
          eventBus.emit('userRefresh')

          // Fetch user profile as with phone login
          try {
            const profileRes = await appClient.post('/profile', {})
            if (profileRes.data && profileRes.data.status && profileRes.data.data && profileRes.data.data.id) {
              this.user = profileRes.data.data
            }
          } catch (profileErr) {
            if (this.user) this.user = null
          }
          this.showEmailSheet = false
          await this.fetchCastingDetail()
          this.postLoginCandidateFlow()
        } else {
          this.emailVerifyError = response.data.message || 'Email o password non validi.'
        }
      } catch (error) {
        this.emailVerifyError = error.response?.data?.message || 'Errore durante il login.'
      } finally {
        this.isLoading = false;
      }
    },
    async handlePhoneLogin(phone) {
      this.phoneVerifyError = null
      this.isLoading = true;
      this.phone = phone;
      try {
        const response = await appClient.post('/phone/verify', { phone })
        if (response.data && response.data.success) {
          this.phoneVerifyJwt = response.data.jwt
          this.showPhoneSheet = false
          this.showPhoneCodeSheet = true
        } else {
          this.phoneVerifyError = response.data.message || 'Errore durante la verifica del telefono.'
        }
      } catch (error) {
        this.phoneVerifyError = error.response?.data?.message || 'Errore durante la verifica del telefono.'
      } finally {
        this.isLoading = false;
      }
    },
    async handlePhoneCodeConfirm(code) {
      this.phoneCodeError = null
      this.isLoading = true;
      try {
        const response = await appClient.post('/phone/verify/confirm', {
          jwt: this.phoneVerifyJwt,
          otp: code
        })
        if (response.data && response.data.success) {
          // Fetch possible profiles
          try {
            const profilesRes = await appClient.post('/phone/profiles', { phone_token: response.data.phone_token });
            if (profilesRes.data.profiles && Array.isArray(profilesRes.data.profiles) && profilesRes.data.profiles.length > 0) {
              if (profilesRes.data.profiles.length === 1) {
                // Only one profile, select automatically
                await this._continueLoginWithProfile(response.data.phone_token, profilesRes.data.profiles[0]);
                this.showPhoneCodeSheet = false;
                this.isLoading = false;
                return;
              } else {
                this.profileOptions = profilesRes.data.profiles;
                this.showProfileSelectSheet = true;
                this.showPhoneCodeSheet = false;
                // Store phone_token for later use
                this._pendingPhoneToken = response.data.phone_token;
                this.isLoading = false;
                return; // Wait for user to select a profile
              }
            }
          } catch (profilesErr) {
            // eslint-disable-next-line no-console
            console.error('Error fetching profiles:', profilesErr);
          }
          // If no profiles or error, fallback to previous flow
          await this._continueLoginWithProfile(response.data.phone_token, null);
        } else {
          this.phoneCodeError = response.data.message || 'Codice OTP non valido.'
        }
      } catch (error) {
        this.phoneCodeError = error.response?.data?.message || 'Codice OTP non valido.'
      } finally {
        this.isLoading = false;
      }
    },
    async handleProfileSelect(profile) {
      this.isLoading = true;
      this.selectedProfile = profile;
      this.showProfileSelectSheet = false;
      // Continue login with selected profile
      await this._continueLoginWithProfile(this._pendingPhoneToken, profile);
      this._pendingPhoneToken = null;
      // Refetch casting details after profile is set
      await this.fetchCastingDetail();
      this.postLoginCandidateFlow();
      this.isLoading = false;
    },

    async _continueLoginWithProfile(phone_token, selectedProfile) {
      this.isLoading = true;
      // Send phone_token and selected profile (if any) to external API
      try {
        const loginPayload = { phone_token };
        if (selectedProfile && selectedProfile.id) {
          loginPayload.profile_id = selectedProfile.id;
        }
        const loginRes = await appClient.post('/login', loginPayload);
        const apiData = loginRes.data;
        if (apiData && apiData.status && apiData.data) {
          // Existing user
          this.appUser = apiData.data;
          this.appToken = apiData.data.token;
          localStorage.setItem('castingup_app_token', apiData.data.token);

          console.log('userRefresh event emitted')
          eventBus.emit('userRefresh')
          // Now call /profile to get canonical user info
          try {
            const profileRes = await appClient.post('/profile', {});
            if (profileRes.data && profileRes.data.status && profileRes.data.data) {
              this.user = profileRes.data.data;
            }
          } catch (profileErr) {
            // fallback: clear user if /profile fails
            if (this.user) this.user = null;
          }
          // Refetch casting details after profile is set
          await this.fetchCastingDetail();
          this.postLoginCandidateFlow();
        } else {
          // New user
          this.appUser = null;
          this.appToken = null;
          this.showSuccessModal = false;
          this.showNewUserSheet = true;
          // Store phone_token and casting id for onboarding navigation
          this._pendingPhoneToken = phone_token;
          this._pendingCastingId = this.$route.params.id || this.castingId;
        }
      } catch (loginErr) {
        // If API call fails, treat as new user
        this.appUser = null;
        this.appToken = null;
        this.showSuccessModal = false;
        this.showNewUserSheet = true;
        // Store phone_token and casting id for onboarding navigation
        this._pendingPhoneToken = phone_token;
        this._pendingCastingId = this.$route.params.id || this.castingId;
      } finally {
        this.isLoading = false;
      }
    },

    handleStartOnboarding() {
      this.showNewUserSheet = false;
      // Pass phone_token and returnTo (casting page) as query params
      document.querySelector('#app').scrollTo({ top: 0, behavior: 'smooth' });
      this.$router.push({
        path: '/profile',
        query: {
          phone_token: this._pendingPhoneToken,
          returnTo: `/casting/${this._pendingCastingId || this.$route.params.id || this.castingId}`
        }
      });
    },

    async handlePhoneCodeResend() {
      // Try to use the last phone used for login
      const phone = this.phone;
      this.phoneCodeResendSuccess = false;
      if (!phone) {
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: "Numero di telefono non disponibile.",
            type: 'error'
          });
        }
        return;
      }
      this.isLoading = true;
      try {
        const response = await appClient.post('/phone/verify', { phone });
        if (response.data && response.data.success) {
          this.phoneCodeResendSuccess = true;
          this.phoneVerifyJwt = response.data.jwt;
        } else {
          this.phoneCodeResendSuccess = false;
          if (typeof window !== 'undefined' && window.$toast) {
            window.$toast({
              message: response.data.message || "Errore durante l'invio del codice.",
              type: 'error'
            });
          }
        }
      } catch (error) {
        this.phoneCodeResendSuccess = false;
        if (typeof window !== 'undefined' && window.$toast) {
          window.$toast({
            message: error.response?.data?.message || "Errore durante l'invio del codice.",
            type: 'error'
          });
        }
      } finally {
        this.timer = 300;
        this.isLoading = false;
      }
    }
  }
}
</script>
